
import AHDate from "_shared/dates/date";
export default async function dashboardLoader() {
  return new AHDate().TimeOfDayGreeting;
}
